export default {"src":"/_next/static/media/download-icon.722784f4.svg","height":21,"width":19};